import React from 'react';
import { Navigate, useRoutes } from 'react-router-dom';
import ProtectedRoute from '@/components/ProtectedRoute';
import Layout from '@/themes';
import Login from '@/pages/Login';
import Home from '@/pages/Home';
import DataReport from '@/pages/DataReport';
import OosEmailReport from '@/pages/OosEmailReport';

function Router() {
  return useRoutes([
    { path: '/login', element: <Login /> },
    {
      path: '/',
      element: (
        <ProtectedRoute>
          <Layout />
        </ProtectedRoute>
      ),
      children: [
        { index: true, element: <Home /> },
        { path: 'data-report', element: <DataReport /> },
        { path: 'oos-email-report', element: <OosEmailReport /> },
      ],
    },
    { path: '*', element: <Navigate to="/" replace /> },
  ]);
}

export default Router;
